import { Reveal } from "@components/ui";

const coreValues = [
  {
    title: "Integrity",
    desc: "Acting with transparency, honesty, and ethical commitment in every transaction.",
  },
  {
    title: "Safety First",
    desc: "Protecting people and property through certified systems and constant vigilance.",
  },
  {
    title: "Innovation",
    desc: "Leveraging technology to enhance accuracy, accessibility, and sustainability.",
  },
  {
    title: "Customer Focus",
    desc: "Simplifying processes, offering clarity, and ensuring satisfaction.",
  },
  {
    title: "Accountability",
    desc: "Delivering measurable results and maintaining full regulatory compliance.",
  },
];

export function AboutMissionVisionSection() {
  return (
    <section className="w-full py-14 md:py-16 lg:py-20 px-5 md:px-10 lg:px-[180px] bg-[#f9f9fb]">
      <div className="w-full max-w-[1368px] mx-auto flex flex-col gap-12 md:gap-14">
        <Reveal direction="up">
          <div className="rounded-2xl bg-white overflow-hidden">
            <div className="grid grid-cols-1 md:grid-cols-2 divide-y md:divide-y-0 md:divide-x divide-[#e9e8e6]">
              <div className="p-8 md:p-10 flex flex-col gap-5">
                <div className="flex items-center gap-3">
                  <div className="w-2 h-2 rounded-full bg-[#34A12E]" />
                  <span className="text-[13px] font-semibold tracking-[0.08em] uppercase text-[#34A12E]">
                    Our Mission
                  </span>
                </div>
                <p className="text-[18px] md:text-[22px] lg:text-[26px] tracking-[-0.03em] text-[#090d2c] leading-[1.45] font-medium">
                  To deliver safe, smart, and sustainable gas solutions that
                  empower communities, enhance efficiency, and uphold the
                  highest standards of customer trust and regulatory compliance.
                </p>
              </div>
              <div className="p-8 md:p-10 flex flex-col gap-5">
                <div className="flex items-center gap-3">
                  <div className="w-2 h-2 rounded-full bg-[#f24d2b]" />
                  <span className="text-[13px] font-semibold tracking-[0.08em] uppercase text-[#f24d2b]">
                    Our Vision
                  </span>
                </div>
                <p className="text-[18px] md:text-[22px] lg:text-[26px] tracking-[-0.03em] text-[#090d2c] leading-[1.45] font-medium">
                  To become the UAE's most trusted and innovative provider of
                  gas distribution, metering, and billing services — championing
                  sustainability and digital transformation in energy management.
                </p>
              </div>
            </div>
          </div>
        </Reveal>

        <div className="flex flex-col gap-6">
          <Reveal direction="up">
            <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-2">
              <h2 className="text-[24px] md:text-[32px] lg:text-[40px] font-semibold tracking-[-0.04em] text-[#122d63]">
                Our Core Values
              </h2>
              <p className="text-[14px] md:text-[16px] tracking-[-0.02em] text-[#62636c]">
                The principles that guide every decision we make.
              </p>
            </div>
          </Reveal>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
            {coreValues.map((val, i) => (
              <Reveal key={i} direction="up" delay={i * 50}>
                <div className="h-full rounded-2xl bg-white p-5 flex flex-col gap-2.5 border border-[#e9e8e6] hover:border-[#f24d2b]/30 hover:shadow-sm transition-all duration-300">
                  <div className="w-8 h-8 rounded-lg bg-[#f24d2b]/10 flex items-center justify-center text-[#f24d2b] text-[14px] font-bold">
                    {String(i + 1).padStart(2, "0")}
                  </div>
                  <h4 className="text-[16px] md:text-[18px] lg:text-[20px] font-semibold tracking-[-0.03em] text-[#090d2c]">
                    {val.title}
                  </h4>
                  <p className="text-[13px] md:text-[14px] lg:text-[15px] tracking-[-0.02em] text-[#62636c] leading-[1.5]">
                    {val.desc}
                  </p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
